import * as moment from 'moment';

export class DateTimeConfig {
    public static date: moment.Moment;
    public minDate: moment.Moment;
    public maxDate: moment.Moment;
    public stepHour = 1;
    public stepMinute = 1;
}
